const initFilterSearch = () => {
    const searchContainersList = document.querySelectorAll("[data-search-container]");
    if (searchContainersList && searchContainersList.length > 0) {
        searchContainersList.forEach((searchContainer) => {
            const searchFilterButton = searchContainer.querySelector("[data-search-btn-filter]");
            const inputTextSearch = searchContainer.querySelector("[data-input-search]");
            if (searchFilterButton) {
                searchFilterButton.addEventListener("click", () => {
                    const paramsQueryString = `?src=${encodeURI(inputTextSearch.value)}`;
                    if (searchFilterButton.hasAttribute("data-href")) {
                        if (inputTextSearch.value != "") {
                            window.location.href = `${searchFilterButton.getAttribute("data-href")}${paramsQueryString}`;
                        }
                        else {
                            window.location.href = searchFilterButton.getAttribute("data-href");
                        }
                    }
                    else {
                        window.location.href = paramsQueryString;
                    }
                });
                inputTextSearch.addEventListener("keyup", (e) => {
                    if (e.keyCode === 13) {
                        // Cancel the default action, if needed
                        e.preventDefault();
                        // Trigger the button element with a click
                        searchFilterButton.click();
                    }
                });
            }
        });
    }
};
